import * as React from 'react';
import { observer } from 'mobx-react-lite';
import './ContractComparisonPanelHeader.less';

interface Props {
    panelName: string;
    changeSummaryLabel: string;
}

const ContractComparisonPanelHeader: React.FC<Props> = ({ panelName, changeSummaryLabel }) => {
    return (
        <div className="contract-comparison-panel-header">
            <span className="header-title">{panelName}</span>
            <span className="header-change-count">{changeSummaryLabel}</span>
        </div>
    );
};

export default observer(ContractComparisonPanelHeader);
